module.exports = __webpack_public_path__ + "static/media/loc1_img15.6d1c09f6.jpg";